import React from 'react'
import NotFound from '../Pages/NotFound'

import { Box, Stack, Typography } from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/pro-duotone-svg-icons/faSync'

import { Trans } from 'react-i18next'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            error: null,
            errorInfo: null,
            hasError: false,
        }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
        })
    }

    async clearCachesAndRefresh() {
        if (caches) {
            const names = await caches.keys()
            await Promise.all(names.map((name) => caches.delete(name)))
        }

        window.location.reload(true)
    }

    render() {
        const { hasError, error, errorInfo } = this.state

        if (
            hasError &&
            error &&
            error.toString().toLowerCase().indexOf('chunk') !== -1
        ) {
            return (
                <Box
                    className="mainContainer"
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        p: 3,
                    }}
                >
                    <Stack spacing={2} alignItems="flex-start">
                        <Typography variant="h4">
                            <Trans i18nKey="New release">New release</Trans>
                        </Typography>

                        <Typography>
                            <Trans i18nKey="new_release_description">
                                There is a new release please click on the
                                button to refresh or hit (Ctrl + F5) or (Ctrl +
                                Shift + R).
                            </Trans>
                        </Typography>

                        <Stack direction="row" spacing={2}>
                            <StyledButton
                                size="small"
                                dense
                                variant="contained"
                                onClick={this.clearCachesAndRefresh}
                            >
                                <FontAwesomeIcon icon={faSync} />
                            </StyledButton>

                            <StyledButton
                                size="small"
                                dense
                                variant="contained"
                                onClick={() => window.location.reload(true)}
                            >
                                <FontAwesomeIcon icon={faSync} />
                            </StyledButton>
                        </Stack>
                    </Stack>
                </Box>
            )
        }

        return hasError ? (
            <NotFound
                {...this.props}
                errorType={'dossier'}
                error={error}
                errorInfo={errorInfo}
            />
        ) : (
            this.props.children
        )
    }
}
